import { render, staticRenderFns } from "./SetDetails.vue?vue&type=template&id=5752f345&scoped=true&"
import script from "./SetDetails.vue?vue&type=script&lang=js&"
export * from "./SetDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetDetails.vue?vue&type=style&index=0&id=5752f345&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752f345",
  null
  
)

export default component.exports